exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{font-family:futura-pt,Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#1a1a1a}h1,h2,h3,h4,h5,h6{font-family:Avenir,Helvetica,Arial,sans-serif}a{text-decoration:none!important}#build-nav a,#nav a{color:#1a1a1a!important;display:-webkit-box;display:-ms-flexbox;display:flex}#build-nav a .v-btn,#nav a .v-btn{-ms-flex-item-align:inherit;align-self:inherit}#nav a.router-link-exact-active{color:#006aff}", ""]);

// exports
